<div data-testid="document-detail-dialog">
  <mat-toolbar class="detail-toolbar">
    <h4 class="detail-toolbar__title">{{ 'enter_product_details_tr' | translate }}</h4>
    <button mat-stroked-button (click)="addRow()" [disabled]="form.invalid" type="button">
      <mat-icon>add</mat-icon>
      <span class="btn-label">{{ 'add_row_tr' | translate }}</span>
    </button>
    <button mat-raised-button [mat-dialog-close]="formData()" [disabled]="form.invalid" color="primary" type="button">
      <mat-icon>save</mat-icon>
      <span class="btn-label">{{ 'Save_tr' | translate }}</span>
    </button>
    <button mat-raised-button mat-dialog-close type="button" data-testid="document-detail-close-button">
      <mat-icon>close</mat-icon>
      <span class="btn-label">{{ 'close_tr' | translate }}</span>
    </button>
  </mat-toolbar>

<mat-dialog-content class="detail-dialog-content">
  <app-info-text url="/wiki/adding-quantities">
    {{ 'Optional_quantities_and_HS_codes_are_not_tr' | translate }}
  </app-info-text>
  <form [formGroup]="form">
    <mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef>{{ 'product_specification_tr' | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let row" [formGroup]="row" [attr.data-label]="'product_specification_tr' | translate">
          <mat-form-field appearance="fill">
            <input matInput formControlName="name" placeholder="" />
          </mat-form-field>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="hsCode">
        <mat-header-cell *matHeaderCellDef>{{ 'hs_code_tr' | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let row" [formGroup]="row" [attr.data-label]="'hs_code_tr' | translate">
          <div class="hs-code-field">
            <mat-form-field appearance="fill" floatLabel="always">
              <hscode-selector #hsCodeSelector="hscodeSelector" formControlName="hsCode"></hscode-selector>
              @if (hsCodeSelector.hints.length) {
                <!-- One mat-hint per align: Material throws in dev mode on a second one. -->
                <mat-hint class="hs-warning">
                  @for (hint of hsCodeSelector.hints; track hint.key) {
                    <div>{{ hint.key | translate: hint.params }}</div>
                  }
                </mat-hint>
              }
            </mat-form-field>
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="quantity">
        <mat-header-cell *matHeaderCellDef>{{ 'Quantity_tr' | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let row" [formGroup]="row" [attr.data-label]="'Quantity_tr' | translate">
          <mat-form-field appearance="fill">
            <input matInput formControlName="quantity" type="number" class="text-right" />
          </mat-form-field>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="unit">
        <mat-header-cell *matHeaderCellDef>{{ 'Unit_tr' | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let row" [formGroup]="row" [attr.data-label]="'Unit_tr' | translate">
          <mat-form-field appearance="fill">
            <mat-select formControlName="unit" placeholder="Select unit">
              @for (unit of units; track unit) {
                <mat-option [value]="unit">{{ unit }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="edit">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let row; let i = index">
          <button mat-icon-button (click)="deleteRow(i)" type="button">
            <mat-icon>delete</mat-icon>
          </button>
        </mat-cell>
      </ng-container>

      <mat-row *matRowDef="let row; columns: ['name', 'hsCode', 'quantity', 'unit', 'edit']"></mat-row>
      <mat-header-row *matHeaderRowDef="['name', 'hsCode', 'quantity', 'unit', 'edit']"></mat-header-row>
    </mat-table>
  </form>
</mat-dialog-content>
</div>
